/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import { listAttachments, scrollToTop } from '../../../../assets/ts/general/general'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import FileUpload from '../../../../components/file-upload/file-upload'
import { UserContext } from '../../../../store/user-context-provider'
import { NO_CHANGE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import InputText from '../../../../utils/controls/input-text'

const AddEditView = (props: any) => {
  const { me } = useContext(UserContext)

  const [fileError, setFileError] = useState(false)
  const [replaceFile, setReplaceFile] = useState(false)
  const [showAlert, setShowAlert] = useState(false)

  const [files, setFiles] = useState([])
  const titleRef: any = useRef<any>(null)
  const descriptionRef = useRef<any>(null)
  const [folderValidations, setFolderValidations] = useState<any>({
    Name: false,
    duplicateName: '',
    noFile: false,
  })
  const [inputValues, setInputValues] = useState({
    Name: props?.editFile ? props?.fileName.split('.').slice(0, -1).join('.') : '',
    type: props?.editFile ? props?.fileName.split('.')[props?.fileName.split('.').length - 1] : '',
  })

  if (props?.showAddPopup) {
    scrollToTop()
  }
  function changeTitle(e: { target: { value: any } }) {
    setInputValues({ ...inputValues, Name: e.target.value })
  }
  useEffect(() =>{
    const titleElemnt = document.getElementById('Name')
    if(titleRef?.current && titleElemnt){
      if(props?.clickedIndex === 0){
        descriptionRef?.current?.scrollIntoView({behavour: 'auto', block: 'end'})
        titleElemnt.focus()
      }else if(props?.clickedIndex === 1){
        descriptionRef?.current?.scrollIntoView({behavour: 'auto', block: 'nearest'})
        titleElemnt.focus()
      }else{
        titleRef?.current?.scrollIntoView(false)
        titleElemnt.focus()
      }
    }
  }, [titleRef, props?.editFolder, descriptionRef])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const saveorupdate = async (folder: any, items: string) => {
    let isValid = true
    let checkTitle = true
    let IsDuplicateFolderName = true
    let duplicateName = ''
    let noFile = false

    if (!inputValues.Name) {
      isValid = false
      checkTitle = false
    } else if (props?.folderNames?.length > 0 && props?.addFolder) {
      props?.folderNames.forEach((element: { folderName: any }) => {
        if (
          element?.folderName?.toString().toLowerCase() ===
          inputValues?.Name?.toString().toLowerCase()
        ) {
          IsDuplicateFolderName = false
        }
      })
    }
    if (!IsDuplicateFolderName) {
      isValid = false
      checkTitle = false
      duplicateName = 'Entered Folder Name Already Exists'
    }

    if (files.length > 0) {
      isValid = true
    } else {
      if (props?.addFile) {
        isValid = false
        checkTitle = false
        noFile = true
      }
    }
    if (props?.editFile && inputValues.Name.trim() === '') {
      isValid = false
      checkTitle = false
    }
    setFolderValidations({
      ...folderValidations,
      Name: !checkTitle,
      duplicateName: duplicateName,
      noFile: noFile,
    })

    if (props?.fileName?.split('.')
      ?.slice(0, -1)?.join('.') === inputValues.Name) {
        isValid = false
        setShowAlert(true)
      }
  

    if (isValid) {
      const promises: any = []
      if (files?.length > 0) {
        const list = await mpfRListsHttp().getList('PolicyMemoAndGuidelinesList')
        const pmgData: any = await list.query().filter(`Path eq '${props?.path}'`).get()

        const item = {
          Path: props?.path || '',
          eKey: '',
          eTag: '',
        }

        const pmgEntry: any = pmgData.length >= 1 ? pmgData[0] : await list.addOrUpdateItem(item)

        promises.push(
          listAttachments('PolicyMemoAndGuidelinesList', pmgEntry.eKey, files, props?.path)
        )
      } else if (props?.editFile && props?.editedFile) {
        const list = await mpfRListsHttp().getList('PolicyMemoAndGuidelinesList')
        const pmgData: any = await list.query().filter(`Path eq '${props?.path}'`).get()

        const listBlobs = await list.blobs()

        const file = props?.editedFile
        const etag = props?.editedFile?.Id

        try {
          await listBlobs.blobMove(
            pmgData[0].eKey as string,
            file.title,
            props?.path,
            etag,
            `${inputValues.Name}.${inputValues.type}`
          )
        } catch (err) {
          console.error(err)
        }
      }

      await Promise.all(promises)
      props?.onCancel()
      props?.setFetchFiles(!props?.fetchFiles)
    }
  }

  const onClickAlert = () => {
    setShowAlert(false)
  }

  return (
    <div
      className={
        props?.showAddEdit
          ? 'mx-2 border-radius whitebg border-primary mt-2'
          : 'settingseditpopup w-100 position-relative border-top1 mt-2'
      }
      id='scroll'
    >
      {showAlert && (
          <Alert
            alerttextclass='poppins-semibold font-13 text-center'
            btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
            btn1iconclassNmae='icon-checked font-12 pe-1'
            btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
            btn2iconclassNmae='icon-close color-primary font-12 pe-1'
            cancel='Cancel'
            className='alert-info'
            message={NO_CHANGE_MESSAGE}
            onClick={onClickAlert}
            yes='OK'
          />
        )}
      {props?.showAddEdit && !props?.addFolderFile && (
        <div className='p-3 border-bottom1 '>
          <h4
            aria-label={
              (props?.addFolder && 'ADD FOLDER') ||
              (props?.editFolder && 'EDIT FOLDER') ||
              (props?.editFile && 'EDIT File') ||
              (props?.addFile && 'ADD Files')
            }
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            {props?.addFolder && <span>ADD FOLDER</span>}
            {props?.editFolder && <span>EDIT FOLDER</span>}
            {props?.editFile && <span>EDIT File</span>}
            {props?.addFile && <span>ADD Files</span>}
          </h4>
        </div>
      )}
      <div className='px-2 py-1'>
        <div className='row'>
          {(props?.addFolder || props?.editFolder || props?.editFile) &&
            !props?.addFile &&
            !props?.addFolderFile && (
              <div className='col-sm-12 col-lg-12 mb-2' ref={titleRef}>
                <InputText
                  changeHandler={changeTitle}
                  error={folderValidations.Name}
                  errorMsg={folderValidations?.duplicateName}
                  formClassName='d-flex flex-column'
                  info='Name '
                  infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                  infoIcon='icon-info color-primary'
                  inputProps={{
                    className: 'poppins-medium font-12 title-color2 mb-1',
                    id: 'Name',
                    maxLength: 256,
                    name: 'Name',
                    placeholder: 'Enter Name',
                    value: inputValues.Name,
                  }}
                  isInfo
                  isMandatory
                  label=' Name'
                  spanValue={inputValues?.type}
                />
              </div>
            )}
          {!props?.editFile &&
            (props?.addFile || props?.addFolderFile) &&
            !props?.addFolder &&
            !props?.editFolder && (
              <div className='col-sm-12 col-lg-12 mb-2'>
                <FileUpload
                  filesProps={{ files, setFiles }}
                  formClassName='d-flex flex-column'
                  hint='Upload the files which are in the .png, .jpeg, .xlsx, .txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen'
                  hintClassName='color-primary'
                  info='Attach file (s) '
                  infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                  infoIcon='icon-info color-primary'
                  inputProps={{
                    className: 'poppins-medium font-12 title-color2 mb-1',
                    id: 'Attach files ',
                    name: ' Description',
                  }}
                  isInfo
                  isMandatory
                  label='Attach file (s) '
                  note='Screenshots need to be saved locally before uploading into system.'
                  noteClassName='color-primary'
                  replaceFileProps={{replaceFile, setReplaceFile}}
                  setFileError={setFileError}
                />
              </div>
            )}
          {folderValidations?.noFile && (
            <span
              className='errormsg'
              id='docerrormsg'
              style={{ textAlign: 'left', verticalAlign: 'bottom' }}
            >
              Please choose file(s) to upload.
            </span>
          )}
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {props?.showAddEdit && !props?.fileName && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={() => {
                    // setccordion({
                    //   status: false,
                    //   rowKey: null
                    // })
                    saveorupdate(props?.fileName, '')
                  }}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    props?.onCancel()
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {props?.fileName && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={() => {
                    saveorupdate(props?.fileName, props?.details?.Name)
                  }}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => props?.onCancel()}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
